


import { mapState } from 'vuex'
export default {
data () {
return {
height: screen.height - 46
}
},
props: {
hasFooter: {
type: Boolean,
default: false
},
hasHeader: {
type: Boolean,
default: false
},
},
components: {

},
beforeCreate () {
},
mounted () {

},
beforeDestroy () {

},
methods: {

},
computed: {
...mapState({
deviceInfo: state => state.user.deviceInfo,
}),
},
}



// WEBPACK FOOTER //
// ./src/common/components/page/PageContent.vue